<template>
  <div class="wrapper">
    <header class="header">
      <div class="inner container">
        <img
          src="@/assets/img/chinese/index/header/logo-white.png"
          alt="당근중국어"
          class="logo"
        />
        <ul class="menu-list">
          <li @click="goFreeClass">화상 무료수업 신청</li>
          <li @click="goCon4">커리큘럼</li>
          <li @click="goEnrolment">수강신청</li>
        </ul>
      </div>
    </header>
    <article class="head">
      <VueSlickCarousel v-bind="mainSettings" class="main-slick">
        <div class="slide-con1">
          <div class="container">
            <div class="today-class">
              <p>오늘의 수업만족도</p>
              <div>
                <span
                  v-for="row in resData.smile"
                  :key="row.id"
                  :class="{ none: row == '.' }"
                  >{{ row }}</span
                >
                <p>/5.0점</p>
              </div>
            </div>
            <p class="head-text">
              당근이니까<br /><span>중국어</span> 시작도 가능
            </p>
            <ul class="go-class">
              <li @click="goFreeClass">화상 무료수업 신청하기</li>
              <li @click="goEnrolment">수강 신청하기</li>
            </ul>
            <img
              src="@/assets/img/chinese/index/head/img1-m.png"
              alt="img"
              class="img1-m"
            />
            <img
              src="@/assets/img/chinese/index/head/img1-pc.png"
              alt="img"
              class="img1-pc"
            />
            <p class="fiy">
              팔선생 캐릭터는 팔선생 중국어를 쉽고 재미있게 접근할 수 있도록
              도와줍니다.
            </p>
          </div>
        </div>
        <div class="slide-con2">
          <div class="container">
            <img
              src="@/assets/img/chinese/index/head/event/event1/text-m.png"
              alt="img"
              class="text-m"
            />
            <img
              src="@/assets/img/chinese/index/head/event/event1/text-pc.png"
              alt="img"
              class="text-pc"
            />
            <ul class="go-class">
              <li @click="goFreeClass">무료 수업 받아보기</li>
              <li @click="goEnrolment">수강 신청하고 혜택받기</li>
            </ul>
            <img
              src="@/assets/img/chinese/index/head/event/event1/icon-m.png"
              alt="img"
              class="icon-m"
            />
            <img
              src="@/assets/img/chinese/index/head/event/event1/icon-pc.png"
              alt="img"
              class="icon-pc"
            />
          </div>
        </div>
      </VueSlickCarousel>
    </article>

    <div class="showFixed">
      <Con1></Con1>

      <Con2></Con2>

      <article class="con3">
        <div class="container">
          <p>수업 스타일, 실력 향상 스토리</p>
          <p>한 발 더 앞선 나를 위한<br />개인 맞춤형 수업 관리</p>
          <ul>
            <li>
              <img src="@/assets/img/chinese/index/con3/left.png" alt="img" />
            </li>
            <li>
              <img src="@/assets/img/chinese/index/con3/right.png" alt="img" />
            </li>
          </ul>
        </div>
      </article>

      <Con4 id="con4"></Con4>

      <Con5></Con5>

      <article class="con6"></article>
    </div>

    <Footer></Footer>

    <div class="channel-talk" @click="openChannelTalk">
      <img
        src="@/assets/img/chinese/index/talk-m.png"
        alt="icon"
        class="talk-m"
      />
      <img
        src="@/assets/img/chinese/index/talk-pc.png"
        alt="icon"
        class="talk-pc"
      />
    </div>

    <!-- <div class="fixed">
      <div class="inner" @click="goFreeClass">
        <p>무료 수업 신청하기</p>
        <div>
          <img src="@/assets/img/chinese/index/go.png" alt="icon" />
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { ref } from "vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import Con1 from "@/components/Carrotchinese/con1.vue";
import Con2 from "@/components/Carrotchinese/con2.vue";
import Con4 from "@/components/Carrotchinese/con4.vue";
import Con5 from "@/components/Carrotchinese/con5.vue";
import Footer from "@/components/Carrotchinese/footer.vue";
import * as ChannelService from "@channel.io/channel-web-sdk-loader";

export default {
  components: { VueSlickCarousel, Con1, Con2, Con4, Con5, Footer },
  data() {
    return {
      mainSettings: {
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 2500,
        cssEase: "ease-out",
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1049,
            settings: {
              arrows: false,
            },
          },
        ],
      },
      resData: [],
    };
  },
  metaInfo: {
    title: "당근중국어",
    meta: [
      {
        name: "naver-site-verification",
        content: "1a9562186f5d32af6eeebf18306eeab7b2a02dcc",
      },
      {
        name: "facebook-domain-verification",
        content: "lyceoxwtl9uotvzyidyj5vp8ylkmud",
      },
      {
        name: "keywords",
        content:
          "전화중국어, 화상중국어, 중국어회화, 당근중국어, 당근주니어중국어",
      },
      {
        name: "description",
        content:
          "당근 중국어 티칭경력 5년 이상의 차별화된 중국 원어민 선생님, 전화중국어, 화상중국어, 중국어회화 1:1맞춤수업, 다양한 주제와 체계적인 커리큘럼.",
      },
      { name: "viewport", content: "width=device-width" },
      { property: "og:type", content: "website" },
      { property: "og:title", content: "당근중국어" },
      {
        property: "og:description",
        content:
          "당근 중국어 티칭경력 5년 이상의 차별화된 중국 원어민 선생님, 전화중국어, 화상중국어, 중국어회화 1:1맞춤수업, 다양한 주제와 체계적인 커리큘럼",
      },
      { property: "og:url", content: "https://www.carrotchinese.co.kr" },
      {
        property: "og:image",
        content: "https://www.carrotchinese.co.kr/img/img1-pc.a8813b79.png",
      },
    ],
  },
  methods: {
    goFreeClass() {
      location.href = "/freeClass";
    },
    goEnrolment() {
      window.open("https://carrotenglish.kr/phone/register?lang=cn", "_blank");
    },
    goEvent() {
      window.open(
        "https://www.carrotenglish.kr/phone/bbs_event_view/440",
        "_blank"
      );
    },
    goCon4() {
      const con4 = document.getElementById("con4");
      con4.scrollIntoView({ behavior: "smooth" });
    },

    // 채널톡
    openChannelTalk() {
      ChannelService.loadScript();
      ChannelService.boot({
        pluginKey: "652f8e43-1d56-41b7-b594-bd6c8f2bd4e4",
        hideChannelButtonOnBoot: true,
      });
      ChannelService.openSupportBot(90657);
      ChannelService.openChat();
    },

    // 오늘의 수업만족도
    getTodaySatisfaction() {
      axios
        .get("https://carrotenglish.kr/rest_free/phone/report_ch")
        .then((res) => {
          if (res.data.err === 0) {
            this.resData = res.data;
            // console.log(res.data);
            // console.log(res.data.smile);
          } else {
            console.error("res.data.err : ", res.data.err);
          }
        })
        .catch((err) => {
          alert("통신이 원활하지 않습니다.");
          console.error("err : ", err);
        });
    },

    // 헤더 색 변경
    headerChange() {
      const mainHeader = document.querySelector(".header");
      const logoImg = document.querySelector(".logo");

      if (window.scrollY > 0) {
        mainHeader.classList.add("active");
        logoImg.src = `${require("@/assets/img/chinese/index/header/logo-black.png")}`;
      } else {
        mainHeader.classList.remove("active");
        logoImg.src = `${require("@/assets/img/chinese/index/header/logo-white.png")}`;
      }
    },
  },
  mounted() {
    // 무료 수업 신청하기
    // const showFixed = document.querySelector(".showFixed");
    // const fixed = document.querySelector(".fixed");
    // function handleScroll() {
    //   const showFixedRect = showFixed.getBoundingClientRect();

    //   if (
    //     showFixedRect.top >= 0 ||
    //     showFixedRect.bottom <= window.innerHeight
    //   ) {
    //     fixed.style.bottom = "-70px";
    //   } else {
    //     fixed.style.bottom = "0px";
    //   }
    // }
    // window.addEventListener("scroll", handleScroll);

    // 오늘의 수업만족도
    this.getTodaySatisfaction();

    window.addEventListener("scroll", this.headerChange);
  },
};
</script>
<style lang="scss" scoped>
@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css");

img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.wrapper {
  font-family: "Pretendard", "Malgun Gothic", "맑은고딕", sans-serif;
}

.container {
  max-width: calc(100% - 40px);
  margin: 0 auto;

  @media screen and (min-width: 1050px) {
    max-width: 1000px;
  }
}

// 헤더
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;

  &.active {
    background-color: rgba($color: #ffffff, $alpha: 0.85);
    transition: 0.5s;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);

    .inner {
      .menu-list {
        color: #09090b;
      }
    }
  }

  .inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 15px 0;

    .logo {
      width: 67px;

      @media screen and (min-width: 1050px) {
        width: 112px;
      }
    }

    .menu-list {
      display: flex;
      gap: 12px;
      font-size: 12px;
      font-weight: 500;
      color: #ffffff;

      @media screen and (min-width: 1050px) {
        font-size: 16px;
        gap: 35px;
      }

      li {
        cursor: pointer;
      }
    }
  }
}

// 헤드
.head {
  .slide-con1 {
    position: relative;
    background: url(~@/assets/img/chinese/index/head/bg.png) no-repeat center /
      cover;
    padding-top: 120px;

    @media screen and (min-width: 1050px) {
      padding-top: 194px;
    }

    &::before {
      @media screen and (min-width: 1050px) {
        content: "";
        display: block;
        width: 564px;
        height: 719px;
        background: url(~@/assets/img/chinese/index/head/img-pc1.png) no-repeat
          center / contain;
        position: absolute;
        top: 0;
        left: 0;
        mix-blend-mode: soft-light;
      }
    }

    &::after {
      @media screen and (min-width: 1050px) {
        content: "";
        display: block;
        width: 546px;
        height: 302px;
        background: url(~@/assets/img/chinese/index/head/img-pc2.png) no-repeat
          center / contain;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 1;
        mix-blend-mode: soft-light;
      }
    }

    .today-class {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;
      margin-bottom: 32px;

      @media screen and (min-width: 1050px) {
        flex-direction: row;
        justify-content: center;
        align-items: flex-end;
        gap: 11px;
      }

      > p {
        font-size: 18px;
        color: #ffffff;

        @media screen and (min-width: 1050px) {
          font-size: 29px;
        }
      }

      > div {
        display: flex;
        align-items: flex-end;
        gap: 5px;

        @media screen and (min-width: 1050px) {
          gap: 8px;
        }

        span {
          font-size: 26px;
          font-weight: 500;
          color: #ffffff;
          text-align: center;
          line-height: 33px;
          width: 33px;
          height: 33px;
          background-color: #26292a;
          border-radius: 6px;

          &.none {
            line-height: normal;
            width: auto;
            height: auto;
            background-color: transparent;
            border-radius: 0;
            margin: -4px;
          }

          @media screen and (min-width: 1050px) {
            font-size: 44px;
            line-height: 50px;
            width: 50px;
            height: 50px;
            background-color: #26292a;
          }
        }

        p {
          font-size: 18px;
          color: #ffffff;

          @media screen and (min-width: 1050px) {
            font-size: 29px;
          }
        }
      }
    }

    .head-text {
      font-size: 40px;
      font-weight: 800;
      color: #ffffff;
      text-align: center;
      margin-bottom: 30px;

      @media screen and (min-width: 1050px) {
        font-size: 80px;
        margin-bottom: 36px;
      }

      span {
        color: #fed60e;
      }
    }

    .go-class {
      display: flex;
      justify-content: center;
      gap: 17px;
      max-width: 334px;
      margin: 0 auto 20px;

      @media screen and (min-width: 1050px) {
        max-width: 515px;
        margin: 0 auto;
        justify-content: space-between;
        gap: 37px;
        margin-bottom: 23px;
      }

      li {
        width: 100%;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
        padding: 15px 0;
        border: 1px solid #ffffff;
        border-radius: 10px;
        cursor: pointer;

        @media screen and (min-width: 1050px) {
          font-size: 22px;
          padding: 22px 0;
          border-radius: 15px;
        }
      }
    }

    .img1-m {
      @media screen and (min-width: 1050px) {
        display: none;
      }
    }

    .img1-pc {
      display: none;

      @media screen and (min-width: 1050px) {
        display: block;
        max-width: 630px;
        margin: 0 auto;
      }
    }

    .fiy {
      display: none;

      @media screen and (min-width: 1050px) {
        display: block;
        position: absolute;
        right: 48px;
        bottom: 39px;
        font-size: 14px;
        color: #ffffff;
      }
    }
  }

  .slide-con2 {
    position: relative;
    background: url(~@/assets/img/chinese/index/head/event/event1/bg-m.png)
      no-repeat center / cover;
    padding-top: 190px;

    @media screen and (min-width: 1050px) {
      padding-top: 194px;
      background: url(~@/assets/img/chinese/index/head/event/event1/bg-pc.png)
        no-repeat center / cover;
    }

    .text-m {
      width: 276px;
      margin: 0 auto 56px;

      @media screen and (min-width: 1050px) {
        display: none;
      }
    }

    .text-pc {
      display: none;

      @media screen and (min-width: 1050px) {
        display: block;
        width: 670px;
        margin: 0 auto 64px;
      }
    }

    .go-class {
      display: flex;
      justify-content: center;
      gap: 17px;
      max-width: 334px;
      margin: 0 auto;

      @media screen and (min-width: 1050px) {
        max-width: 515px;
        margin: 0 auto;
        justify-content: space-between;
        gap: 37px;
      }

      li {
        width: 100%;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
        padding: 15px 0;
        border: 1px solid #ffffff;
        border-radius: 10px;
        cursor: pointer;

        @media screen and (min-width: 1050px) {
          font-size: 22px;
          padding: 22px 0;
          border-radius: 15px;
        }
      }
    }

    .icon-m {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);

      @media screen and (min-width: 1050px) {
        display: none;
      }
    }

    .icon-pc {
      display: none;

      @media screen and (min-width: 1050px) {
        display: block;
        width: 942px;
      }
    }
  }

  :deep(.main-slick) {
    .slick-list {
      .slick-track {
        display: flex;
        align-items: stretch;
        .slick-slide {
          height: auto;
          > div {
            height: 100%;
            > div {
              height: 100%;
            }
          }
        }
      }
    }

    .slick-arrow {
      z-index: 1;

      &.slick-prev {
        left: 92px;
        width: 90px;
        height: 90px;
        background: url(~@/assets/img/chinese/index/head/btn-prev.png) no-repeat
          center / contain;

        &::before {
          display: none;
        }
      }

      &.slick-next {
        right: 92px;
        width: 90px;
        height: 90px;
        background: url(~@/assets/img/chinese/index/head/btn-next.png) no-repeat
          center / contain;

        &::before {
          display: none;
        }
      }
    }

    .slick-dots {
      display: flex !important;
      justify-content: center;
      align-items: center;
      bottom: 30px;

      li {
        width: 7px;
        height: 7px;
        background-color: rgba($color: #fff, $alpha: 0.4);
        border-radius: 100%;
        margin: 0;

        @media screen and (min-width: 1200px) {
          width: 10px;
          height: 10px;
        }

        &:not(:last-child) {
          margin-right: 12px;
        }

        &.slick-active {
          background-color: #fff;
        }

        button {
          display: none;
        }
      }
    }
  }
}

// con3
.con3 {
  padding: 85px 0;
  background-color: #f1edfd;

  @media screen and (min-width: 1050px) {
    padding: 160px 0;
  }

  .container {
    > p {
      text-align: center;

      &:nth-of-type(1) {
        font-size: 16px;
        font-weight: 700;
        color: #7b53eb;
        margin-bottom: 16px;

        @media screen and (min-width: 1050px) {
          font-size: 28px;
          margin-bottom: 44px;
        }
      }

      &:nth-of-type(2) {
        font-size: 30px;
        font-weight: 700;
        color: #09090b;
        margin-bottom: 37px;

        @media screen and (min-width: 1050px) {
          font-size: 50px;
          margin-bottom: 114px;
        }
      }
    }

    > ul {
      position: relative;
      display: flex;
      flex-direction: column;

      @media screen and (min-width: 1050px) {
        flex-direction: row;
      }

      &::after {
        content: "";
        width: 131px;
        height: 140px;
        background: url(~@/assets/img/chinese/index/con3/icon.png) no-repeat
          center / contain;
        position: absolute;
        right: 17px;
        bottom: 0;

        @media screen and (min-width: 1050px) {
          width: 207px;
          height: 212px;
          right: 14px;
        }
      }
    }
  }
}

// con6
.con6 {
  position: relative;
  height: 80px;
  background: url(~@/assets/img/chinese/index/con6/img.png) no-repeat center /
    2079px 24px;
  animation: 50s marquee infinite linear;

  @media screen and (min-width: 1050px) {
    height: 262px;
    background: url(~@/assets/img/chinese/index/con6/img.png) no-repeat center /
      5000px 60px;
  }
}

@keyframes marquee {
  0% {
    background-position-x: 0%;
  }

  100% {
    background-position-x: 100%;
  }
}

// 채널톡
.channel-talk {
  position: fixed;
  right: 20px;
  bottom: 70px;
  z-index: 2;
  cursor: pointer;

  @media screen and (min-width: 1050px) {
    right: 10px;
  }

  .talk-m {
    width: 48px;

    @media screen and (min-width: 1050px) {
      display: none;
    }
  }

  .talk-pc {
    display: none;

    @media screen and (min-width: 1050px) {
      display: block;
      width: 152px;
    }
  }
}

// 무료 수업 신청하기
.fixed {
  position: fixed;
  bottom: -70px;
  left: 0;
  width: 100%;
  background-color: darkslateblue;
  transition: 0.2s all linear;

  .inner {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 20px 0;
    background-color: #558fff;
    cursor: pointer;

    @media screen and (min-width: 1050px) {
      padding: 22px 0;
    }

    p {
      font-weight: 500;
      color: #ffffff;

      @media screen and (min-width: 1050px) {
        font-size: 20px;
      }
    }

    div {
      width: 4px;

      @media screen and (min-width: 1050px) {
        width: 5px;
      }
    }
  }
}
</style>
